import { Routes } from '@angular/router';
import { authGuard } from '@core/guards';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: 'auth-callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback.component').then((m) => m.AuthCallbackComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
    title: 'Btg Market Agent | Login'
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
    data: {
      accessDenied: true
    },
    title: 'Btg Market Agent | Access Denied'
  },
  {
    path: '',
    loadComponent: () => import('./pages/main/main').then((m) => m.Main),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'reports',
        title: 'Btg Market Agent | Reports'
      },
      {
        path: 'reports',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/reports/reports').then((m) => m.ReportsComponent),
            title: 'Btg Market Agent | Reports'
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/reports/reports-detail/reports-detail').then((m) => m.ReportsDetail),
            title: 'Btg Market Agent | Report Detail'
          }
        ]
      }
    ]
  }
];
